import React, { Fragment } from 'react'

// Joins multiple inline components into a sentence structure
// e.g.:
// const Reindeer = ({name}) => <span style={{color: 'red}}>{name}</span>
// makeSentence([<Reindeer name="Dasher" />, <Reindeer name="Dancer" />, <Reindeer name="Bumpy />")
// => Dasher, Dancer, and Bumpy
export const makeConjunction = (components: React.ReactNode[]) => (
  <Fragment>
    {components.map((component, index) => {
      let distanceFromEnd = components.length - 1 - index
      let adjoiningString = ', '
      if (distanceFromEnd === 0) {
        adjoiningString = ''
      } else if (distanceFromEnd === 1) {
        adjoiningString = ' and '
      }
      return (
        <Fragment key={index}>
          {component}
          {adjoiningString}
        </Fragment>
      )
    })}
  </Fragment>
)
